import { getSharePointTextFileContent } from 'owa-groups-services/lib/getSharePointTextFileContent';
import { getSharePointTextFileContentOverride } from 'owa-groups-adaptors';
import { PerformanceDatapoint, DatapointStatus } from 'owa-analytics';
import {
    logResponseDataForOwaServerCalls,
    isServiceFetchError,
} from 'owa-server-call-logging/lib/owaServerCallLogging';
import { getErrorFromObject } from '../logging/genericInformationLogging';

const CLIENT_ACTION_NAME_PREFIX = 'GetSharePointTextFileContent-FH-REACT-';

const parseGetSharePointTextFileContentResponse = (
    response: any,
    datapoint: PerformanceDatapoint
): string => {
    datapoint.addCheckmark('ParsingResponse');

    if (response && response.Content != null) {
        datapoint.end();
        return response.Content;
    } else {
        datapoint.endWithError(DatapointStatus.ServerError, new Error('Null response from server'));
        return null;
    }
};

export function getContentOfSharePointTextFile(
    id: string,
    url: string,
    actionSource: 'Prefetch' | 'Preview' | 'PreviewInNewSxS' | 'Test'
): Promise<string> {
    const datapoint = new PerformanceDatapoint('GroupFilesHubGetSharePointTextFileContentActionDP');

    datapoint.addCustomProperty('actionSource', actionSource);
    if (getSharePointTextFileContentOverride) {
        return getSharePointTextFileContentOverride(id, url)
            .then((response: any) => {
                const parsedReponse = parseGetSharePointTextFileContentResponse(
                    response,
                    datapoint
                );
                datapoint.end();
                return parsedReponse;
            })
            .catch(error => {
                datapoint.endWithError(DatapointStatus.ServerError, getErrorFromObject(error));
                throw new Error('GetSharePointTextFileContentAction failed.');
            });
    } else {
        return getSharePointTextFileContent(id, url, CLIENT_ACTION_NAME_PREFIX + actionSource)
            .then((response: any) => {
                const parsedReponse = parseGetSharePointTextFileContentResponse(
                    response,
                    datapoint
                );
                datapoint.end();
                return parsedReponse;
            })
            .catch(error => {
                if (error && isServiceFetchError(error)) {
                    logResponseDataForOwaServerCalls(datapoint, error.response);
                }

                datapoint.endWithError(DatapointStatus.ServerError, getErrorFromObject(error));
                throw new Error('GetSharePointTextFileContentAction failed.');
            });
    }
}
